var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThankyouCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9987 0.333496C12.2787 0.333496 0.332031 12.2802 0.332031 27.0002C0.332031 41.7202 12.2787 53.6668 26.9987 53.6668C41.7187 53.6668 53.6654 41.7202 53.6654 27.0002C53.6654 12.2802 41.7187 0.333496 26.9987 0.333496ZM26.9987 48.3335C15.2387 48.3335 5.66536 38.7602 5.66536 27.0002C5.66536 15.2402 15.2387 5.66683 26.9987 5.66683C38.7587 5.66683 48.332 15.2402 48.332 27.0002C48.332 38.7602 38.7587 48.3335 26.9987 48.3335ZM39.2387 15.2135L21.6654 32.7868L14.7587 25.9068L10.9987 29.6668L21.6654 40.3335L42.9987 19.0002L39.2387 15.2135Z",
    fill: "#16B27E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouCheck);
export default __webpack_public_path__ + "static/media/thankyou-check.55d6cd04eaa056e23ae9b526941724f2.svg";
export { ForwardRef as ReactComponent };